import { render, staticRenderFns } from "./taxesTransactionCriteria.vue?vue&type=template&id=7211b8dc&scoped=true&"
import script from "./taxesTransactionCriteria.vue?vue&type=script&lang=js&"
export * from "./taxesTransactionCriteria.vue?vue&type=script&lang=js&"
import style0 from "./taxesTransactionCriteria.vue?vue&type=style&index=0&id=7211b8dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7211b8dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCol,VRow,VSwitch})
